import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-8 flex justify-center" }
const _hoisted_2 = { class: "bg-amber-50 p-8 rounded-full ring-8 ring-amber-50/50" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl md:text-4xl font-bold text-gray-800 mb-4" }, " Não foi possível carregar suas permissões ", -1)
const _hoisted_4 = {
  class: "text-gray-500 text-lg mb-2 leading-relaxed max-w-lg mx-auto",
  "data-testid": "permissions-unavailable-message"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 mb-10 leading-relaxed max-w-lg mx-auto" }, " Por segurança, o acesso fica bloqueado até elas carregarem. ", -1)
const _hoisted_6 = { class: "flex flex-col sm:flex-row gap-4 justify-center items-center w-full" }

import { computed, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { mdiCloudOffOutline } from '@mdi/js'
import { useErrorToast } from '@/composables/useErrorToast'
import { useAuthStore } from '@/pinia-store/useAuthStore'
import { PERMISSIONS_LOAD_ERROR, usePermissionsStore } from '@/pinia-store/usePermissionsStore'
import PATHS from '@/router/paths'
import { PERMISSIONS_UNAVAILABLE_ROUTE_NAME, resolveRetryTarget } from './retryTarget'


export default /*#__PURE__*/_defineComponent({
  __name: 'PermissionsUnavailable',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()
const permissionsStore = usePermissionsStore()
const { loadError } = storeToRefs(permissionsStore)
const { notifyErrorMessage } = useErrorToast()

// A store zera o `loadError` enquanto o retry voa; a tela mantém o último erro
// visível em vez de piscar a mensagem padrão.
const lastError = ref(loadError.value)
watch(loadError, (value) => {
  if (value) lastError.value = value
})
const message = computed(() => lastError.value ?? PERMISSIONS_LOAD_ERROR)
const isRetrying = ref(false)

onMounted(() => {
  // Sem falha registrada (acesso direto com as permissões carregadas, ou sem
  // sessão): não há o que tentar de novo. O guard do dashboard decide o resto.
  if (!loadError.value) router.replace(PATHS.DASHBOARD)
})

function retryTarget(): string {
  const target = resolveRetryTarget(route.query.redirect)
  // Variacoes do proprio caminho (barra final, caixa) casam nesta mesma rota e
  // prenderiam o usuario aqui depois de um retry bem-sucedido.
  return router.resolve(target).name === PERMISSIONS_UNAVAILABLE_ROUTE_NAME
    ? PATHS.DASHBOARD
    : target
}

async function retry() {
  if (isRetrying.value) return
  isRetrying.value = true
  try {
    await permissionsStore.fetchPermissions()
    // Falhou de novo: fica aqui, já com a mensagem da nova tentativa. O toast
    // avisa mesmo quando o texto é idêntico ao anterior. `fetchPermissions` não
    // rejeita — o erro já chega como mensagem exibível em `loadError`.
    if (permissionsStore.loadError) {
      notifyErrorMessage(permissionsStore.loadError)
      return
    }
    // O guard da rota de destino ainda confere as permissões recém-carregadas.
    await router.replace(retryTarget())
  } finally {
    isRetrying.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "h-screen flex items-center justify-center bg-gray-50/50",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        justify: "center",
        align: "center",
        class: "text-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "8",
            lg: "6"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_v_icon, {
                    icon: _unref(mdiCloudOffOutline),
                    size: "100",
                    class: "text-amber-600"
                  }, null, 8, ["icon"])
                ])
              ]),
              _hoisted_3,
              _createElementVNode("p", _hoisted_4, _toDisplayString(message.value), 1),
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  class: "w-full sm:w-auto h-[56px] font-bold capitalize px-8 text-white",
                  elevation: "0",
                  loading: isRetrying.value,
                  "data-testid": "permissions-unavailable-retry-button",
                  onClick: retry
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Tentar novamente ")
                  ]),
                  _: 1
                }, 8, ["loading"]),
                _createVNode(_component_v_btn, {
                  variant: "outlined",
                  color: "primary",
                  class: "w-full sm:w-auto h-[56px] font-bold capitalize px-8",
                  elevation: "0",
                  disabled: isRetrying.value,
                  "data-testid": "permissions-unavailable-logout-button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(authStore).logout()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Sair ")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})